import { ref, computed } from 'vue';
import { getFormSchema } from '@/services/api/forms';

/**
 * Composable para carregar e gerenciar o schema do formulário
 * Carrega a estrutura completa do Form Builder via API
 */
export function useFormSchema(slug) {
  const schema = ref(null);
  const loading = ref(false);
  const error = ref(null);

  // Computed properties do schema
  const isWizard = computed(() => schema.value?.is_wizard ?? false);
  const steps = computed(() => schema.value?.steps ?? []);
  const fields = computed(() => schema.value?.fields ?? []);
  const settings = computed(() => schema.value?.settings ?? {});
  const facialEnabled = computed(() => schema.value?.enable_facial_recognition ?? false);
  const identificationEnabled = computed(() => schema.value?.enable_identification_step ?? true);
  const identificationField = computed(() => schema.value?.identification_field ?? 'email');
  const successScreen = computed(() => schema.value?.success_screen ?? {
    title: null,
    message: null,
    icon: null
  });
  const submitText = computed(() => schema.value?.submit_text ?? 'Enviar');
  const showProgress = computed(() => schema.value?.show_progress ?? true);
  const autoSave = computed(() => schema.value?.auto_save ?? false);

  /**
   * Busca o schema do formulário da API
   */
  const fetchSchema = async () => {
    loading.value = true;
    error.value = null;

    try {
      const response = await getFormSchema(slug);
      schema.value = response.data;
      return schema.value;
    } catch (err) {
      error.value = err.response?.data?.message || 'Erro ao carregar formulário';
      console.error('Erro ao carregar schema do formulário:', err);
      throw err;
    } finally {
      loading.value = false;
    }
  };

  /**
   * Limpa o schema (útil para cleanup)
   */
  const reset = () => {
    schema.value = null;
    error.value = null;
    loading.value = false;
  };

  return {
    // State
    schema,
    loading,
    error,

    // Computed
    isWizard,
    steps,
    fields,
    settings,
    facialEnabled,
    identificationEnabled,
    identificationField,
    successScreen,
    submitText,
    showProgress,
    autoSave,

    // Methods
    fetchSchema,
    reset
  };
}
